<template>
    <div>
        <Modal v-model="visible" width="1100px" title="线下培训数" :footer-hide="true" :mask-closable="false" class="my-modal top">
            <div class="table-box">
                <loading :isShow="listLoading" />
                <Table :columns="columns" :data="tableData">
                    <template slot-scope="{ row }" slot="signIn">
                        <i-switch v-model="row.signIn" :true-value="1" :false-value="0" @on-change="switchChange(row, $event)"></i-switch>
                    </template>
                </Table>
                <div class="pageBox">
                    <Page
                        :total="total"
                        :current="pageNum"
                        :page-size="pageSize"
                        show-total
                        @on-change="getList"
                        style="text-align: center"
                    />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
export default {
    components: {},
    mixins: [pageTool],
    props: [],
    data() {
        return {
            visible: false,
            listLoading: false,
            loading: false,
            formData: {},
            columns: [
                {
                    title: '培训专题',
                    key: 'themeName',
                    align: 'center',
                    tooltip: true,
                    minWidth: 150
                },
                {
                    title: '培训内容',
                    key: 'content',
                    align: 'center',
                    render(h, params) {
                        let text = params.row.content;
                        return h(
                            'Tooltip',
                            {
                                class: 'flex-center',
                                props: { placement: 'bottom-start', transfer: true }
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'txt-ellipsis2'
                                    },
                                    text
                                ),
                                h('span', { slot: 'content' }, text)
                            ]
                        );
                    }
                },
                {
                    title: '培训老师',
                    key: 'teachers',
                    align: 'center'
                },
                {
                    title: '培训地址',
                    key: 'address',
                    align: 'center',
                    render(h, params) {
                        let text = params.row.address;
                        return h(
                            'Tooltip',
                            {
                                class: 'flex-center',
                                props: { placement: 'bottom-start', transfer: true }
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'txt-ellipsis2'
                                    },
                                    text
                                ),
                                h('span', { slot: 'content' }, text)
                            ]
                        );
                    }
                },
                {
                    title: '培训开始时间',
                    key: 'startTime',
                    width: '140',
                    align: 'center',
                    render(h, params) {
                        const date = params.row.startTime.substring(0, 16);
                        return <span>{date}</span>;
                    }
                },
                {
                    title: '培训结束时间',
                    key: 'endTime',
                    width: '140',
                    align: 'center',
                    render(h, params) {
                        const date = params.row.endTime.substring(0, 16);
                        return <span>{date}</span>;
                    }
                },
                {
                    title: '培训时长',
                    key: 'timeLength',
                    align: 'center',
                    tooltip: true,
                    render(h, params) {
                        return <span>{params.row.timeLength}小时</span>;
                    }
                },
                {
                    title: '是否签到',
                    key: 'signIn',
                    align: 'center',
                    tooltip: true,
                    render(h, params) {
                        return <span>{params.row.signIn == 1 ? '已签到' : '未签到'}</span>;
                    }
                }
            ],
            tableData: [], //表格数据
            total: 0, //表格记录数
            pageSize: 10, //页容量
            pageNum: 1 //当前页Size
        };
    },
    created() {},
    methods: {
        open(data = {}) {
            this.formData.agentId = data.agentId;
            this.visible = true;
            this.getList();
        },
        // 获取列表
        getList() {
            this.$http({
                url: '/buz/staffTrainRecord/read/offDetail',
                type: 'POST',
                data: {
                    ...this.formData,
                    pageSize: this.pageSize,
                    pageNo: this.pageNum
                }
            }).then(res => {
                this.tableData = res.data;
                this.total = res.total;
            });
        },

        // 分页
        pageChange(pageNo) {
            this.pageNum = pageNo;
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
.table-box {
    margin-top: 10px;
}
</style>
